module.exports = __webpack_public_path__ + "img/Material3.020c0eaa.gif";